var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3553 5.15848C14.3655 5.30061 14.3655 5.44277 14.3655 5.58489C14.3655 9.91989 11.066 14.9148 5.03553 14.9148C3.17766 14.9148 1.45178 14.3767 0 13.4428C0.263969 13.4732 0.51775 13.4834 0.791875 13.4834C2.32484 13.4834 3.73603 12.9656 4.86294 12.0824C3.42131 12.0519 2.21319 11.1077 1.79694 9.80823C2 9.83867 2.20303 9.85898 2.41625 9.85898C2.71066 9.85898 3.00509 9.81836 3.27919 9.74733C1.77666 9.44273 0.649719 8.12295 0.649719 6.52905V6.48845C1.08625 6.73211 1.59391 6.88439 2.13194 6.90467C1.24869 6.31583 0.670031 5.31077 0.670031 4.1737C0.670031 3.56458 0.832437 3.0062 1.11672 2.51889C2.73094 4.50873 5.15734 5.8082 7.87812 5.95036C7.82737 5.7067 7.79691 5.45292 7.79691 5.19911C7.79691 3.39198 9.25884 1.91992 11.0761 1.91992C12.0202 1.91992 12.873 2.31586 13.472 2.95545C14.2131 2.81333 14.9238 2.5392 15.5532 2.16358C15.3096 2.92502 14.7918 3.56461 14.1116 3.97067C14.7715 3.89964 15.4111 3.71686 15.9999 3.46308C15.5533 4.1128 14.9949 4.69145 14.3553 5.15848V5.15848Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitterIcon);
export default __webpack_public_path__ + "static/media/footerTwitterIcon.3bb70f8092132db1db507628c8cbd9d0.svg";
export { ForwardRef as ReactComponent };